
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    city: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d5danendcu97hjrn46n0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          phone: '',
          email: '',
          service: '',
          city: '',
          message: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary-600 to-primary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="font-display font-bold text-5xl md:text-6xl mb-6">
              İletişim
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Yangın güvenliği konusunda size yardımcı olmak için buradayız
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <h2 className="font-display font-bold text-3xl text-dark-900 mb-8">
                İletişim Bilgileri
              </h2>
              
              <div className="space-y-6 mb-12">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-dark-900 mb-1">Telefon</h3>
                    <a href="tel:+905319619192" className="text-dark-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                      0531 961 91 92
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-dark-900 mb-1">E-posta</h3>
                    <a href="mailto:info@ipekyanginsondurme.com" className="text-dark-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                      info@ipekyanginsondurme.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-dark-900 mb-1">Adres</h3>
                    <p className="text-dark-600">
                      Kopça Sokak No:33/3<br />
                      Siteler, Altındağ / Ankara
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-2xl text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-dark-900 mb-1">Çalışma Saatleri</h3>
                    <p className="text-dark-600">
                      Pazartesi - Cumartesi<br />
                      08:00 - 18:00
                    </p>
                  </div>
                </div>
              </div>

              {/* Social Media */}
              <div>
                <h3 className="font-display font-semibold text-xl text-dark-900 mb-4">
                  Sosyal Medya
                </h3>
                <div className="flex space-x-4">
                  <a href="#" className="w-12 h-12 bg-dark-100 rounded-lg flex items-center justify-center hover:bg-primary-600 hover:text-white transition-all cursor-pointer" aria-label="Facebook">
                    <i className="ri-facebook-fill text-xl"></i>
                  </a>
                  <a href="#" className="w-12 h-12 bg-dark-100 rounded-lg flex items-center justify-center hover:bg-primary-600 hover:text-white transition-all cursor-pointer" aria-label="Instagram">
                    <i className="ri-instagram-line text-xl"></i>
                  </a>
                  <a href="#" className="w-12 h-12 bg-dark-100 rounded-lg flex items-center justify-center hover:bg-primary-600 hover:text-white transition-all cursor-pointer" aria-label="Twitter">
                    <i className="ri-twitter-x-line text-xl"></i>
                  </a>
                  <a href="#" className="w-12 h-12 bg-dark-100 rounded-lg flex items-center justify-center hover:bg-primary-600 hover:text-white transition-all cursor-pointer" aria-label="LinkedIn">
                    <i className="ri-linkedin-fill text-xl"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <h2 className="font-display font-bold text-3xl text-dark-900 mb-8">
                Teklif Formu
              </h2>
              
              <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="contact-form">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-dark-700 mb-2">
                    Ad Soyad *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 border-dark-200 rounded-lg focus:border-primary-500 focus:outline-none transition-colors"
                    placeholder="Adınız ve soyadınız"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-dark-700 mb-2">
                    Telefon *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 border-dark-200 rounded-lg focus:border-primary-500 focus:outline-none transition-colors"
                    placeholder="0XXX XXX XX XX"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-dark-700 mb-2">
                    E-posta *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 border-dark-200 rounded-lg focus:border-primary-500 focus:outline-none transition-colors"
                    placeholder="ornek@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="service" className="block text-sm font-medium text-dark-700 mb-2">
                    Hizmet Seçimi *
                  </label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 border-dark-200 rounded-lg focus:border-primary-500 focus:outline-none transition-colors"
                  >
                    <option value="">Hizmet seçiniz</option>
                    <option value="Yangın Tüpü Satış">Yangın Tüpü Satış</option>
                    <option value="Yangın Tüpü Dolum">Yangın Tüpü Dolum</option>
                    <option value="Yangın Tüpü Bakım">Yangın Tüpü Bakım</option>
                    <option value="Yangın Söndürme Ekipmanları">Yangın Söndürme Ekipmanları</option>
                    <option value="Baca Temizliği">Baca Temizliği</option>
                    <option value="Davlumbaz Temizliği">Davlumbaz Temizliği</option>
                    <option value="Otomatik Davlumbaz Söndürme Sistemi">Otomatik Davlumbaz Söndürme Sistemi</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="city" className="block text-sm font-medium text-dark-700 mb-2">
                    Şehir / İlçe
                  </label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border-2 border-dark-200 rounded-lg focus:border-primary-500 focus:outline-none transition-colors"
                    placeholder="Şehir ve ilçe bilgisi"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-dark-700 mb-2">
                    Mesajınız
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border-2 border-dark-200 rounded-lg focus:border-primary-500 focus:outline-none transition-colors resize-none"
                    placeholder="Detaylı bilgi vermek isterseniz buraya yazabilirsiniz (maksimum 500 karakter)"
                  ></textarea>
                  <p className="text-sm text-dark-500 mt-1">
                    {formData.message.length}/500 karakter
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-primary-600 text-white py-4 rounded-lg font-semibold hover:bg-primary-700 transition-colors disabled:bg-dark-300 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? 'Gönderiliyor...' : 'Teklif Talep Et'}
                </button>

                {submitStatus === 'success' && (
                  <div className="bg-green-50 border-2 border-green-500 rounded-lg p-4 text-green-700">
                    <i className="ri-check-line mr-2"></i>
                    Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border-2 border-red-500 rounded-lg p-4 text-red-700">
                    <i className="ri-error-warning-line mr-2"></i>
                    Bir hata oluştu. Lütfen daha sonra tekrar deneyin veya telefon ile iletişime geçin.
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-dark-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl text-dark-900 mb-8 text-center">
            Konum
          </h2>
          <div className="w-full h-96 bg-dark-200 rounded-xl overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.2267634!2d32.8543!3d39.9334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM!5e0!3m2!1str!2str!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="İpek Yangın Söndürme Konum"
            ></iframe>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
